<style scoped>
#app {
  width: 100%;
  height: 100vh;
  /* background-image: url("../assets/login-bg.png"); */
  /* background-size: cover; */
}
.logo {
  width: 100%;
}
.logo2 {
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
.logo_image {
  width: 175px;
  height: 54px;
  margin: 47px 0px 0px 53px;
}
.logo_image2 {
  width: 100px;
  height: 100px;
}
.logo-form {
  width: 408px;
  height: 800px;
  /* background-color: red; */
  margin: 0 auto;
  text-align: center;
}
.logo-form-title {
  font-family: PingFang SC;
  font-size: 24px;
  font-weight: 500;
  line-height: 45px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #3d3d3d;
  margin: 16px 0px 24px 0px;
}
::v-deep .el-input__inner {
  height: 54px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #dfdfdf;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding-left: 40px;
}
::v-deep .el-input__inner::placeholder {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding-left: 16px;
}
.person_logo {
  width: 24px;
  height: 24px;
  margin: 16px 16px 0px 8px;
}
.verification_img {
  width: 127px;
  height: 46px;
  margin-top: 4px;
}
.df1 {
  display: flex;
  justify-content: end;
}
.mt16 {
  margin-top: 16px;
}
::v-deep .el-button {
  width: 100%;
  border-radius: 35px;
  background: #2e7516;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #ffffff;
  margin-top: 18px;
}

.read {
  text-align: center;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding: 16px 0px 34px 0px;
}
::v-deep .el-checkbox__inner {
  border-radius: 50%;
  margin: 0px 8px;
}
.login-line {
  display: flex;
}
.line1 {
  width: 161px;
  height: 0px;
  border-top: 1px solid #d8d8d8;
}
.line2 {
  flex: 1;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  margin-top: -8px;
}
.dialog-footer-button {
  width: 76px;
  height: 32px;
  border-radius: 2px;
  color: rgba(0, 0, 0, 0.85);
  background: #ffffff;
  line-height: 5px;
  font-size: 14px;
}
.dialog-footer-button2 {
  width: 76px;
  height: 32px;
  border-radius: 2px;
  color: #ffffff;
  background: #2e7516;
  line-height: 5px;
  font-size: 14px;
}

.header h1 {
  width: 100%;
  text-align: center;
  font-size: 24px;
}
.content {
  padding: 0px 20px 20px 20px;
}
.pt8 {
  padding-top: 8px;
}

.fw700 {
  font-weight: 700;
}
.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #0888ff;
  margin-top: 8px;
}
ul {
  margin-left: 40px;
}
.p16 {
  padding: 16px 0px;
}
.ml22 {
  margin-left: 22px;
}
.ml28 {
    margin-left: 28px;
}
.mt24 {
  margin-top: 24px;
}
</style>
<template>
  <div class="app">
    <div class="header">
      <h1>XRION 隐私政策</h1>
    </div>
    <div class="content">
      <p class="pt8 fw700">发布日期：2025年08月01日</p>
      <p class="pt8 fw700">生效日期：2025年08月01日</p>

      <div class="fw700 pt8">
        <div>
          XRION（以下简称"我们"或"XRION"）深知个人信息对您的重要性，我们将按照法律法规要求，采取严格的安全保护措施保护您的个人信息。本隐私政策旨在向您说明我们如何收集、使用、存储和保护您的个人信息，请您在使用我们的服务前仔细阅读并理解本政策。
        </div>
      </div>

      <div class="section-title">一、我们收集的信息</div>
      <p class="ml22">1.您提供的信息</p>
      <ul>
        <li>注册信息：手机号码、电子邮箱、昵称等</li>
        <li>使用服务时上传的内容：翻译文本、语音文件、文档等</li>
        <li>支付信息：如选择付费服务，需提供支付账号相关信息</li>
      </ul>
      <p class="ml22">2.自动收集的信息</p>
      <ul>
        <li>设备信息：设备型号、操作系统版本、唯一设备标识符等</li>
        <li>日志信息：IP地址、访问时间、使用频率等</li>
        <li>位置信息：粗略位置（基于IP地址）</li>
      </ul>
      <p class="ml22">3.第三方信息</p>
      <ul>
        <li>通过第三方账号（如微信、Google）登录时获取的基本资料</li>
      </ul>

      <div class="section-title">二、我们如何使用您的信息</div>
      <p class="ml22">1.核心功能</p>
      <ul>
        <li>提供文本、语音、文档翻译服务</li>
        <li>账户注册、登录与验证</li>
        <li>处理付费服务订单</li>
      </ul>
      <p class="ml22">2.服务优化</p>
      <ul>
        <li>改进翻译算法质量</li>
        <li>优化用户体验</li>
        <li>进行数据分析</li>
      </ul>
      <p class="ml22">3.安全保障</p>
      <ul>
        <li>检测和防范欺诈行为</li>
        <li>保障系统安全运行</li>
      </ul>

      <div class="section-title">三、信息共享与披露</div>
      <p class="ml22">1.严格限制共享</p>
      <p class="ml28">我们不会与第三方共享您的个人信息，除非：</p>

      <ul>
        <li>获得您的明确授权</li>
        <li>为提供特定服务必须共享（如支付处理）</li>
        <li>应法律法规或司法机关要求</li>
      </ul>

      <p class="ml22">2.第三方服务商</p>
      <p class="ml28">
        为保障XRION的稳定运行或实现相关切能，我们可能会接入第三应提供的软件开发包（SDK）实现前述目的。
        我们对接入的相关第三方SDK在服务目录中列明。
        处理个人信息类型：设备标识符（包括IMEI、IDFA、AndroidID、GAID、MAC、OAID、IMSI、MEID、UAID）、设备
        硬件信息（包括设备型号、设备屏幕分辨率、设备硬件制造商、设备产品名称）、操作系统信息（包括操作系统版本、系统名
        称、系统语言）、网络信息（包括网络类型、运营商名称、基站信息、IP地址、WiFi信息、SSID、BSSID）、推送信息日志、
        精确位置信息、软件列表信息（包括软件列表及软件运行列表信息）
      </p>
      <p class="ml28">目前接入第三方SDK如下：</p>
      <p class="ml28">SDK 名称：ali-sms</p>
      <p class="ml28">收集目的：发送短信验证码验证用户身份有效性。</p>
      <p class="ml28">收集的个人信息类型：用户手机号</p>
      <p class="ml28">SDK隐私政策地址：<a href="https://github.com/aliyun/alibaba-cloud-sdk-go" target="_blank">https://github.com/aliyun/alibaba-cloud-sdk-go </a></p>
      
      <p class="ml28 mt24">SDK 名称：stripe</p>
      <p class="ml28">收集目的：用户使用stripe进行支付购买</p>
      <p class="ml28">收集的个人信息类型：手机号、邮箱、银行卡、验证信息</p>
      <p class="ml28">SDK隐私政策地址：<a href="https://github.com/stripe/stripe-go" target="_blank">https://github.com/stripe/stripe-go </a></p>

      <div class="section-title">四、数据存储与保护</div>
      <p class="ml22">1.存储期限</p>
      <ul>
        <li>翻译内容：实时处理，原始内容不存储</li>
        <li>账户信息：直至您注销账户</li>
        <li>日志信息：最长6个月</li>
      </ul>
      <p class="ml22">2.安全措施</p>
      <ul>
        <li>采用SSL/TLS加密传输</li>
        <li>数据存储加密</li>
        <li>严格的访问权限控制</li>
      </ul>

      <div class="section-title">五、您的权利</div>
      <p class="ml22">1.访问与更正</p>
      <p class="ml28">您可以通过账户设置查看和修改个人信息。</p>
      <p class="ml22">2.删除权</p>
      <ul>
        <li>删除单条翻译记录</li>
        <li>注销账户（需联系客服）</li>
      </ul>
      <p class="ml22">3.撤回同意</p>
      <p class="ml28">您可以在设备设置中关闭位置等权限。</p>

      <div class="section-title">六、未成年人保护</div>
      <p class="ml22">1. 我们不会主动收集14周岁以下儿童的个人信息。</p>
      <p class="ml22">2. 14-18周岁用户使用服务需获得监护人同意。</p>

      <div class="section-title">七、政策更新</div>
      <p class="ml22">我们可能适时修订本政策，重大变更将通过显著方式通知您。</p>

      <div class="section-title">八、联系我们</div>
      <p>如对隐私政策有任何疑问，请联系邮箱：<a href="admin@xrion.ai" target="_blank">admin@xrion.ai </a></p>
      <p class="fw700 p16">提示：本隐私政策是XRION服务条款的重要组成部分，请您在使用服务前仔细阅读。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPage",
  data() {
    return {
      dialogVisible: true,
    };
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {},
};
</script>
